<template>
		<div class="gb-background" v-bind:style="styleBackground" v-bind:class="classBackground">
			<div class="gb-today" v-bind:style="styleToday1" v-if="!outOfTermToday" />
			<div class="gb-today" v-bind:style="styleToday2" v-if="isCalendarTickTerm && !outOfTermToday"/>
			<template v-if="isCalendarTickTerm || isCalendarTickDay">
				<div v-for="h in this.$store.getters.holiday" v-bind:key="h.code">
					<div class="gb-holiday" v-bind:style="styleHoliday(h.code,0)"></div>
					<template v-if="isCalendarTickTerm">
						<div class="gb-holiday" v-bind:style="styleHoliday(h.code,1)"></div>
					</template>
				</div>
			</template>
		</div>
</template>
<script>
import { CALENDAR_TICK, UNIT_WIDTH } from '../data/Const';

export default {
	name:"GBLayerBackground",
	methods: {
		toDate:function (str) {
			var arr = (str.substr(0, 4) + '/' + str.substr(4, 2) + '/' + str.substr(6, 2)).split('/');
			return new Date(arr[0], arr[1] - 1, arr[2]);
		},
		
		styleToday: function(index) {
			let offset = index * UNIT_WIDTH.TICK;
			return {
				left: (this.$store.getters.positionToday + offset) + 'px',
				width: (UNIT_WIDTH.TICK - 1) + 'px',
			};
		},
		styleHoliday: function(code, index) {
			let offset = index * UNIT_WIDTH.TICK;
			let specify_date = new Date(this.toDate(code));

			let position = this.$store.getters.positionAnyday(specify_date);
			return {
				left: (position + offset) + 'px',
				width: (UNIT_WIDTH.TICK - 1) + 'px',
			};
		},
	},
	computed: {
		styleBackground: function() {
			let calendar = this.$store.getters.calendar_yearmonth;
			if (!calendar)
				return {};

			let pos_x = 0;
			switch (this.$store.getters.calendarTick) {
			case CALENDAR_TICK.TERM :
			case CALENDAR_TICK.DAY :
				pos_x = -(calendar[0].days[0].weekDayNum * this.$store.getters.unitWidth);
				break;
			default:
				pos_x = 0;
			}

			return {
				'background-position-x': pos_x + 'px',
			};
		},
		classBackground: function() {
			if (this.$store.getters.calendarTick === CALENDAR_TICK.TERM)
				return 'calendar-tick-term'
			if (this.$store.getters.calendarTick === CALENDAR_TICK.DAY)
				return 'calendar-tick-day'
			if (this.$store.getters.calendarTick === CALENDAR_TICK.WEEK)
				return 'calendar-tick-week'

			return '';
		},
		styleToday1: function() {
			return this.styleToday(0);
		},
		styleToday2: function() {
			return this.styleToday(1);
		},
		isCalendarTickTerm: function() {
			return this.$store.getters.calendarTick === CALENDAR_TICK.TERM;
		},
		isCalendarTickDay: function() {
			return this.$store.getters.calendarTick === CALENDAR_TICK.DAY;
		},
		isCalendarTickWeek: function() {
			return this.$store.getters.calendarTick === CALENDAR_TICK.WEEK;
		},
		outOfTermToday: function() {
			return 0 > this.$store.getters.positionToday || this.$store.getters.positionToday > this.$store.getters.innerWidth - this.$store.getters.listWidth;
		},
	},
}
</script>
<style>
	.gb-background {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		background-color: #fff;
		background-repeat: repeat;
	}

	.gb-background.calendar-tick-term {
		background-image : url("../assets/CalendarBG_Term.png");
	}

	.gb-background.calendar-tick-day {
		background-image : url("../assets/CalendarBG_Day.png");
	}

	.gb-background.calendar-tick-week {
		background-image : url("../assets/CalendarBG_Week.png");
	}

	.gb-today {
		position: absolute;
		height: 100%;
		top: 0px;
		background-color: #AEFFBD;
	}
	
	.gb-holiday {
		position: absolute;
		height: 100%;
		top: 0px;
		background-color: #FFF0FF
	}
	
</style>
